export default __webpack_public_path__ + "static/media/Q12021.11572dc4.PDF";